import { COVERAGE } from "@tokenterminal/core/data/coverage"
import Link from "next/link"
import type { ReactNode } from "react"
import { Logo } from "../common/Logo"
import {
  CUSTOMER_SEGMENTS,
  LogoMarquee,
} from "../products/shared/CustomerSegments"

const COVERAGE_STATS = [
  { value: COVERAGE.chains, label: "chains" },
  { value: COVERAGE.apps, label: "applications" },
  { value: COVERAGE.tokenizedAssets, label: "tokenized assets" },
]

/** Split layout of the contact page, modeled on the Explorer sign-up layout. */
export function ContactLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex w-full h-dvh min-h-[600px] items-center justify-center lg:justify-start bg-bg-default">
      <div className="flex flex-col w-full lg:w-[50vw] gap-10 items-center h-full p-8 overflow-y-auto">
        <div className="flex items-center gap-2 w-full">
          <Link href="/" className="self-start">
            <Logo width={140} />
          </Link>
        </div>
        <div className="flex flex-col justify-center w-full max-w-[400px] gap-8 flex-1">
          {children}
        </div>
        <footer className="flex flex-row gap-x-2 items-center text-sm mx-auto text-fg-secondary">
          <Link href="/terms">Terms of use</Link>
          <span>•</span>
          <Link href="/privacy-policy">Privacy policy</Link>
        </footer>
      </div>
      <div className="p-8 pl-0 h-full hidden lg:block">
        <aside className="flex w-[50vw] flex-col h-full rounded-2xl overflow-hidden justify-center gap-12 py-12 px-16 xl:px-20 bg-linear-to-tr from-emerald-600/10 via-emerald-500/5 to-emerald-500/30 dark:from-emerald-600/10 dark:via-emerald-500/5 dark:to-emerald-500/20">
          <div className="flex flex-col gap-3">
            <div className="text-sm text-fg-secondary">Who we work with</div>
            <h2 className="text-[40px] leading-[42px] xl:text-[48px] xl:leading-[50px] tracking-tighter text-fg-default text-balance">
              The data layer behind crypto's leading institutions
            </h2>
          </div>
          <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-4">
              {CUSTOMER_SEGMENTS.map((segment, i) => (
                <section key={segment.label} className="flex flex-col gap-1">
                  <div className="text-xs text-fg-secondary border-b border-border-default pb-2">
                    {segment.label}
                  </div>
                  <LogoMarquee
                    logos={segment.logos}
                    reverse={i % 2 === 1}
                    className="-mx-16 xl:-mx-20"
                  />
                </section>
              ))}
            </div>
            <div className="grid grid-cols-3 gap-6 border-t border-border-default pt-6 [@media(max-height:860px)]:hidden">
              {COVERAGE_STATS.map((stat) => (
                <div key={stat.label} className="flex flex-col">
                  <div className="text-2xl tracking-tight text-fg-default tabular-nums">
                    {stat.value}
                  </div>
                  <div className="text-sm text-fg-secondary">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </aside>
      </div>
    </div>
  )
}
